import React, { useState } from "react";
import "./ajouterProjet.css";
import { API_ROUTES } from "../../utils/constant";
import axios from "axios";

const AjouterProjet = () => {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null); // Utilisation de null pour l'image
  const [description, setDescription] = useState("");
  const [URL, setURL] = useState("");
  const [github, setGithub] = useState("");
  const [Technologies, setTechnologies] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("image", image); // Utilisation de formData pour l'image
      formData.append("description", description);
      formData.append("URL", URL);
      formData.append("github", github);
      formData.append("technologies", Technologies);

      const response = await axios.post(API_ROUTES.PROJETS, formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        });

      if (response.status === 201) {
        setTitle("");
        setImage(null);
        setDescription("");
        setURL("");
        setGithub("");
        setTechnologies("");
        setMessage("Projet ajouté avec succès !");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleImageUpload = (event) => {
    const selectedFile = event.target.files[0]; // Le premier fichier sélectionné
    if (selectedFile) {
      setImage(selectedFile); // Stocker le fichier sélectionné dans le state
      console.log(`Fichier sélectionné : ${selectedFile.name}`);
    }
  };

  return (
    <div className="ajouter-projet">
      <h2>Ajouter un projet</h2>
      <form onSubmit={handleSubmit} method="post">
        <div className="ajouter-projet-input">
          <label htmlFor="title">Titre</label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
        </div>
        <div className="supprimer-projet-input">
          <label htmlFor="image">Image</label>
          <input
            type="file"
            id="image"
           accept="image/png, image/jpeg, image/webp"
            onChange={(event) => handleImageUpload(event)}
          />
        </div>

        <div className="ajouter-projet-input">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </div>
        <div className="ajouter-projet-input">
          <label htmlFor="URL">URL</label>
          <input
            type="text"
            id="URL"
            value={URL}
            onChange={(event) => setURL(event.target.value)}
          />
        </div>
        <div className="ajouter-projet-input">
          <label htmlFor="github">Github</label>
          <input
            type="text"
            id="github"
            value={github}
            onChange={(event) => setGithub(event.target.value)}
          />
        </div>
        <div className="ajouter-projet-input">
          <label htmlFor="Technologies">Technologies</label>
          <input
            type="text"
            id="Technologies"
            value={Technologies}
            onChange={(event) => setTechnologies(event.target.value)}
          />
        </div>
        <button type="submit">Ajouter</button>
        {message && <p className="message-success">{message}</p>}
      </form>
    </div>
  );
};

export default AjouterProjet;
